import { TooltipPositions } from '../../tooltip/Tooltip';
import { withTooltip } from '../../tooltip/withTooltip';

import { IconButton, Icons, IconButtonSize } from './IconButton';

const IconButtonWithTooltip = withTooltip(IconButton);

IconButtonWithTooltip.displayName = 'IconButtonWithTooltip';

export { IconButtonWithTooltip, Icons, TooltipPositions, IconButtonSize };
